import React from 'react';
import { msnAlertMessageLength, msnAlertMessageNumber } from '../../config/AppConfigurator';
import { AlertMessage } from '../../components/AlertMessage/AlertMessage';
import { SelectedAddress } from '../SelectedAddress/SelectedAddress';
import PropTypes from 'prop-types';

/* IMPORTING LOCAL STYLES FOR METER POINT REFERENCE NUMBER */ 
import '../../assets/components/MeterSerialNumber.scss';


export const MeterSerialNumber = ({ 
    regexMSN, 
    queryBtnSpinner, 
    msn='', 
    queryDetails,
    getMSN, 
    getMeterDataEnquiryDetails,
    address 
}) => {
    return (
        <>
            <div className="mb-3">
                <label htmlFor="InputMSN" className="form-label">Search by Meter Serial Number</label>
                <input type="text" className="form-control postcode-input" value={msn}  id="InputMSN" aria-describedby="MSNHelp" onChange={event => getMSN(event)}/>
            </div>
            { msn.length > 0 && msn.length > 14 &&
                <div className="postcode-input">
                    <AlertMessage {...msnAlertMessageLength} />
                </div>
            }
            { queryDetails && queryDetails[0] && queryDetails[0].elecdetails && queryDetails[0].elecdetails.length === 0 &&
                <div className="postcode-input">
                    <AlertMessage {...msnAlertMessageNumber} />
                </div>
            }
            <button disabled={!msn.match(regexMSN)} className="btn btn-danger btn-md meter-serial-number-submit-button" onClick={()=>getMeterDataEnquiryDetails()}>
                { queryBtnSpinner ? 
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    : 
                    'Enquire'
                }
            </button>
            <div className="meter-data-enquiry-panel-component-divider"></div>
            { address && address.length > 0 &&
              <SelectedAddress selectedAddress={ address }  /> 
            }
        </>
    );
};

MeterSerialNumber.propTypes = {
    /* 
      regax MSN core for component
    */ 
      regexMSN: PropTypes.string.isRequired,
    /* 
      address spinner for query button
    */ 
      queryBtnSpinner: PropTypes.bool.isRequired,
    /* 
      msn for the component
    */ 
      msn: PropTypes.string.isRequired,
  }
  
  MeterSerialNumber.defaultProps = {
    /*
        default value if regex MSN core is not given
    */
      regexMSN: '',
    /*
        default value if address button spinner is not given
    */
      queryBtnSpinner: false,
    /*
        default value if mpan is not given
    */
      msn: '',
}